import { __assign } from "tslib";
import React from "react";
import Highlight, { defaultProps } from "prism-react-renderer";
import CopyToClipboard from "react-copy-to-clipboard";
import { createElementClass, createModifierClass } from "../helpers";

var CopyButton = function CopyButton(_a) {
  var code = _a.code,
      _b = _a.placeholder,
      placeholder = _b === void 0 ? "Copy" : _b,
      onCopy = _a.onCopy,
      copyOptions = _a.copyOptions;
  var content = React.createElement(CopyToClipboard, {
    text: code,
    onCopy: onCopy,
    options: copyOptions
  }, React.createElement("span", null, placeholder));
  return React.createElement("div", {
    className: createElementClass("copy-button")
  }, content);
};

export var Code = function Code(_a) {
  var _b = _a.language,
      language = _b === void 0 ? "yaml" : _b,
      _c = _a.highlightTheme,
      highlightTheme = _c === void 0 ? null : _c,
      value = _a.value,
      copyButton = _a.copyButton,
      children = _a.children;
  var code = children ? children : value;

  if (!code) {
    return null;
  }

  var processedCode = code.replace(/&#60;/gm, "<").replace(/^(\$ *)/gm, "");

  if (!processedCode.trim()) {
    return null;
  }

  var CpButton = copyButton ? copyButton : CopyButton;
  var cpButton = React.createElement(CpButton, {
    code: processedCode
  });
  return React.createElement("div", {
    className: createElementClass("code-wrapper")
  }, cpButton, React.createElement("div", {
    className: createElementClass("code-pre-wrapper")
  }, React.createElement(Highlight, __assign({}, defaultProps, {
    code: processedCode,
    theme: highlightTheme,
    language: language
  }), function (_a) {
    var className = _a.className,
        style = _a.style,
        tokens = _a.tokens,
        getLineProps = _a.getLineProps,
        getTokenProps = _a.getTokenProps;
    return React.createElement("pre", {
      className: createElementClass("code-pre") + " " + createModifierClass(language, "code-pre") + " " + className,
      style: style
    }, React.createElement("code", {
      className: createElementClass("code")
    }, tokens.map(function (line, i) {
      return React.createElement("div", __assign({}, getLineProps({
        line: line,
        key: i
      }), {
        key: line + "-" + i
      }), line.map(function (token, key) {
        var tokenProps = getTokenProps({
          token: token,
          key: key
        });
        return !(tokenProps.className.includes("plain") && !tokenProps.children) ? React.createElement("span", __assign({}, getTokenProps({
          token: token,
          key: key
        }))) : null;
      }));
    })));
  })));
};